<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8WDu4j/tc-custom/9781497645783.jpg?1703849067808" alt="This image is the cover for the book Vapor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vapor
      </h1>
      <p class="bookDescription body article font2">
        <b>The Pygmalion myth recast by one of America’s boldest and most bewitching storytellers</b><br/><br/>Anna Graham has one ambition—to be a great actress. The only problem is, she can’t stop being herself. She is proud, stubborn, and moody; according to her acting teacher, she needs to be as bland and pliable as warm wax. Even when she rents a Good Fairy Queen Costume—complete with crown, wand, and wig—and walks the streets of New York City until three thirty in the morning, she fails to be anyone but Anna Graham. “Help,” she thinks, smoking a cigarette in a deserted subway station. “Help!” screams a man at the other end of the platform as two attackers pull him onto the train tracks. Red pepper spray in hand, the Good Fairy Queen rushes to Damon Wetly’s rescue—and Anna’s wish comes true, in the oddest way imaginable.<br/><br/>Locked inside a cage in Wetly’s cloud-filled country home, Anna learns to do everything—walk, talk, think, eat, breathe—differently. When she finally escapes, she becomes a star—as Wetly promised she would. The new-and-improved Anna attracts plenty of admirers—including a paraplegic soap opera celebrity; the world’s most famous supermodel; and a handsome cellist, Weight Watchers counselor, etiquette expert, and exotic dancer named Nathaniel Powers—but she only has eyes for her former captor, the creator of miniature clouds and major actresses. Just when it seems that her fairy tale ending is right around the corner, Anna’s whole world threatens to evaporate into thin air.<br/><br/>Fearless and fascinating, <i>Vapor </i>holds a funhouse mirror up to some of our deepest and most alluring notions about fame, identity, and desire.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Filipacchi
      </h2>
      
      <p class="authorDescription body article">Described by the&#160;<I>New York Times Book Review</I>&#160;as a &ldquo;lovely comic surrealist,&rdquo; Amanda Filipacchi&rsquo;s fiction has been translated into thirteen languages and her nonfiction has appeared in the&#160;<I>New York Times</I>, the&#160;<I>Wall Street Journal</I>, and the&#160;<I>Atlantic</I>. Her novels have been called &ldquo;hilarious and thought-provoking&rdquo;&#160;by Tama Janowitz and &ldquo;whimsical and subversive&rdquo; by Edmund White. Filipacchi earned her MFA in fiction writing from Columbia University.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02aac9c8